import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ordersComponent } from '../components/orders/orders.component';
import { draftOrdersComponent } from '../components/draft-order/draft-orders.component';
import { ordersDetailsComponent } from '../components/order-details/orders-details.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
    data: { title: 'Fleet List' }
  },
  {
    path: '',
    component: ordersComponent,
    // canActivate: [AuthGuard],
    data: { title: 'Fleet Truck' }
  },
  {
    path: 'draft-truck',
    component: draftOrdersComponent,
    // canActivate: [AuthGuard],
    data: { title: 'Draft Fleet Truck' }
  },
  {
    path:'truck-details/:id',
    component : ordersDetailsComponent,
    data:{title:' Truck Details'}
  },
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ordersRoutingModule { }
